'use strict';
var swiper = new Swiper('.swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    freeMode: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

//# sourceMappingURL=index.75f8fd93.js.map
